<template>
    <div>
      <event-line v-for="(event, idx) in timelineEventGroups"
                  :load="load"
                  :show-time="showTime || isLtnAdmin"
                  :key="`timeline-event-${idx}`"
                  :events="timelineObject.events"
                  :participants="_.get(timelineObject, 'participants', [])"
                  :event="event"/>
    </div>
</template>

<script>
import _ from 'lodash';
import EventLine from '@/components/EventLine';
import { timelineEvent } from '@/types';
import { mapGetters } from 'vuex';

export default {
  name: 'Timeline',
  props: {
    timelineObject: {
      type: Object,
      required: true,
    },
    load: {
      type: Object,
      required: false,
    },
    showTime: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    EventLine,
  },
  computed: {
    ...mapGetters('profiles', ['isLtnAdmin']),
    _() {
      return _;
    },
    timelineEventGroups() {
      return this.composeTimelineEventGroups(this.timelineObject);
    },
  },
  methods: {
    composeTimelineEventGroups(timeline) {
      // i hate javascript so much
      const makeComposite = one => ({
        event: timelineEvent.TIMESTAMP_CHANGE_LOG_GROUP,
        userId: one.userId,
        userDisplayName: one.userDisplayName,
        timestamp: one.timestamp,
        items: [one],
      });

      const shouldCollapse = (left, right) => {
        const leftUserId = left.userId || left.userId;
        const rightUserId = right.userId || right.userId;
        return left.timestamp === right.timestamp &&
          leftUserId === rightUserId;
      };

      const timestampedEvents = [];

      _.get(timeline, 'events', []).forEach((event) => {
        const top = timestampedEvents.pop();
        if (!top) {
          // base case.  first time through.
          if (event.event === timelineEvent.CHANGE_LOG) {
            const compy = makeComposite(event);
            timestampedEvents.push(compy);
          } else {
            timestampedEvents.push(event);
          }
        } else {
          // we know we have a previous element
          // eslint-disable-next-line
          if (event.event === timelineEvent.CHANGE_LOG) {
            // current event is a changelog.
            // previous goes back on and this one goes on as as item of the previous
            // or as a new composite
            if (top.event === timelineEvent.TIMESTAMP_CHANGE_LOG_GROUP &&
              shouldCollapse(top, event)) {
              timestampedEvents.push(top);
              top.items.push(event);
            } else {
              const compy = makeComposite(event);
              timestampedEvents.push(top);
              timestampedEvents.push(compy);
            }
          } else {
            timestampedEvents.push(top);
            timestampedEvents.push(event);
          }
        }
      });

      return timestampedEvents;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/timeline/Timeline.vue